import React, { useState, useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import '../App.js';
import { Skeleton } from 'antd';
import '../assets/css/sm.css';

const SocialMediaLinks = () => {
    const location = useLocation();
    const match = matchPath(
        {
            path: "/links/:schoolKey",
            exact: true,
            strict: false,
        },
        location.pathname
    );

    const schoolKey = match ? match.params.schoolKey : null;

    const [data, setData] = useState({});
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [links, setLinks] = useState([]);

    useEffect(() => {
        fetchSchool();
    }, [schoolKey]);

    const fetchSchool = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                "https://liltriangle.b4a.app/examVerification/getLandingPage",
                {
                    method: "POST",
                    body: JSON.stringify({ key: schoolKey }),
                    headers: { "Content-type": "application/json; charset=UTF-8" },
                }
            );

            if (response.ok) {
                const result = await response.json();
                console.log(result);
                setData(result.result);

                let list = [];
                let schoolObject = result.result.object;

                if (schoolObject.instagram) {
                    list.push({ title: "Instagram", url: schoolObject.instagram });
                }

                if (schoolObject.googleReview) {
                    list.push({ title: "Google", url: schoolObject.googleReview });
                }

                if (schoolObject.linkedin) {
                    list.push({ title: "LinkedIn", url: schoolObject.linkedin });
                }

                if (schoolObject.facebook) {
                    list.push({ title: "Facebook", url: schoolObject.facebook });
                }

                if (schoolObject.twitter) {
                    list.push({ title: "X/Twitter", url: schoolObject.twitter });
                }

                if (schoolObject.youtube) {
                    list.push({ title: "YouTube", url: schoolObject.youtube });
                }


                if (schoolKey === "liltriangle") {
                    list.push({ title: "Book a Demo", url: `https://liltriangle.com/book-demo` });
                } else if (result.result.id) {
                    list.push({ title: "Enquiry Us", url: `https://forms.liltriangle.com/enquiry-form/${result.result.id}` });
                }

                if (schoolObject.schoolWebsite) {
                    list.push({ title: "Website", url: schoolObject.schoolWebsite });
                }

                if (schoolObject.whatsappNumber) {
                    const cleanNumber = schoolObject.whatsappNumber.replace(/\D/g, "");
                    list.push({
                        title: "WhatsApp",
                        url: `https://wa.me/${cleanNumber}`,
                    });
                }

                if (schoolObject.location) {
                    list.push({ title: "School Location", url: schoolObject.location });
                }

                setLinks(list);
            } else {
                throw new Error('Network response was not ok.');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="linktree-container">
            {loading ? (
                <div className='text-center'>
                    <Row>
                        <Col lg={12}>
                            <Skeleton.Image active={loading} className='m-2' />
                            <Skeleton.Button active={loading} size={'default'} shape={'default'} block={true} />
                            <Skeleton.Input active={loading} size={'small'} style={{ marginBottom: '1cm' }} />
                        </Col>
                        <Col lg={12}>
                            {[...Array(9)].map((_, i) => (
                                <Skeleton.Button
                                    key={i}
                                    className='m-1'
                                    active={loading}
                                    size={'large'}
                                    shape={'default'}
                                    block={true}
                                />
                            ))}
                        </Col>
                    </Row>
                </div>
            ) : (
                <div>
                    {data && data.schoolLogo && (
                        <img
                            src={data.schoolLogo}
                            alt="Profile"
                            className="profile-img"
                        />
                    )}
                    <h1 className="username">{data.name}</h1>
                    <p className="tagline">{data.object.area}</p>

                    <div className="links-wrapper">
                        {links.map((link, idx) => (
                            <a
                                key={idx}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-button"
                            >
                                {link.title}
                            </a>
                        ))}
                    </div>

                    <div className="contact-buttons">
                        <p className="text-center text-secondary fw-medium my-2">
                            Any queries?
                        </p>
                        {data.object.phoneNumber && (
                            <a href={"tel:" + data.object.phoneNumber} className="contact-button">
                                📞 Call Us
                            </a>
                        )}
                        {data.object.email && (
                            <a href={"mailto:" + data.object.email} className="contact-button">
                                ✉️ Email Us
                            </a>
                        )}
                    </div>

                    <div className="powered-by mt-4">
                        Powered by{" "}
                        <a href="https://liltriangle.com" target="_blank" rel="noopener noreferrer">
                            lilTriangle
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SocialMediaLinks;
